
export default {
  props: {
    header        : {
      type   : String,
      default: null
    },
    code          : null,
    recent        : {
      type   : Boolean,
      default: false
    },
    containerClass: null,
    previewStyle  : null
  },
  data() {
    return {
      BlockView: {
        PREVIEW: 0,
        CODE   : 1
      },
      blockView: 0,
    }
  },
  methods: {
    activateView(event, blockView) {
      this.blockView = blockView;
      event.preventDefault();
    },
    async copyCode(event) {
      await navigator.clipboard.writeText(this.code);
      event.preventDefault();
    }
  }
}
